import { API_BASE_URL } from '../config/env';

const API_ORIGIN = (() => {
  try {
    return new URL(API_BASE_URL).origin;
  } catch (_) {
    return '';
  }
})();

const AUTH_SKIP_UNAUTHORIZED = [
  '/api/auth/login',
  '/api/auth/logout',
  '/api/auth/frontend-status',
  '/api/auth/invite',
  '/api/auth/first-password',
  '/api/auth/register',
  '/api/auth/accept-invite',
  '/api/auth/validate-invite',
  '/api/bot-encuesta/public'
];

export function isPublicAppPath(pathname = '') {
  const p = String(pathname || (typeof window !== 'undefined' ? window.location.pathname : ''));
  return p === '/login'
    || p.startsWith('/super-admin/')
    || p.startsWith('/llamada/')
    || p.startsWith('/encuesta-bot/r/');
}

export function resolveRequestUrl(input) {
  if (!input) return '';
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.href;
  if (typeof input === 'object' && input.url) return String(input.url);
  return '';
}

export function isPulseApiRequest(url) {
  const u = String(url || '');
  if (!u) return false;
  if (u.startsWith('/api/')) return true;
  if (API_ORIGIN && u.startsWith(API_ORIGIN)) return true;
  return u.includes('/api/auth/') || u.includes('/api/asociacion');
}

export function shouldReportUnauthorized(url, status) {
  if (Number(status) !== 401) return false;
  const normalized = String(url || '').toLowerCase();
  if (!isPulseApiRequest(normalized)) return false;
  return !AUTH_SKIP_UNAUTHORIZED.some((segment) => normalized.includes(segment));
}

export async function readUnauthorizedMessage(response) {
  const fallback = 'No autenticado';
  try {
    const ct = response?.headers?.get?.('content-type') || '';
    if (!ct.includes('json')) return fallback;
    const data = await response.clone().json();
    return String(data?.error || data?.message || fallback).trim() || fallback;
  } catch (_) {
    return fallback;
  }
}
